import { longDate } from '@/components/estimating/agreements/agreementFormat';

export const hf = (v) => ({ fontFamily: v.company.fonts?.heading });

// The company's letterhead, the way its invoices open: logo, name, contact · PROPOSAL + the project.
export function ProposalHeader({ v }) {
  const c = v.company;
  return (
    <div className="flex flex-wrap items-start justify-between gap-4 border-b-[3px] pb-5" style={{ borderColor: c.primary }}>
      <div className="min-w-0">
        {c.logo && <img src={c.logo} alt="" className="mb-2 max-h-14 max-w-[220px] object-contain" data-testid="proposal-public-logo" />}
        <p className="font-exo text-lg font-bold text-[#0D1B2A]" style={hf(v)} data-testid="proposal-public-company">{c.name}</p>
        <p className="text-xs text-[#5C6370]">{[c.address, c.phone, c.email, c.website].filter(Boolean).join(' · ')}</p>
      </div>
      <div className="text-left sm:ml-auto sm:text-right">
        <p className="font-exo text-2xl font-bold tracking-[0.06em]" style={{ color: c.primary, ...hf(v) }}>PROPOSAL</p>
        <p className="text-sm font-semibold text-[#0D1B2A]" data-testid="proposal-public-project">{v.project}</p>
      </div>
    </div>
  );
}

// A short note on how the page works.
export function ProposalIntro({ v }) {
  return (
    <div className="space-y-2 py-5 text-sm leading-relaxed text-[#111417]" data-testid="proposal-public-intro">
      <p className="font-semibold" data-testid="proposal-public-greeting">Hi {v.client_first_name},</p>
      {v.can_pick === false ? (
        <p>Here’s your proposal{v.project ? <> for <strong>{v.project}</strong></> : null}. Take a look at the services and the payment terms below.
          When you’re ready, {v.company.name || 'we'} will send it to you to sign.</p>
      ) : (
        <p>Here’s your proposal{v.project ? <> for <strong>{v.project}</strong></> : null}. Services marked <strong>Included</strong> are part of the project.
          Tick the optional ones you’d like, then send us your picks. We’ll send your proposal to sign, built from them.</p>
      )}
      <p className="text-xs text-[#5C6370]" data-testid="proposal-public-expires">
        {v.can_pick === false ? '' : 'You can change your picks until your proposal is sent for signing. '}This link works until {longDate(v.expires_on)}.</p>
    </div>
  );
}
